module.exports = __webpack_public_path__ + "static/finovate-spring-2016-afc36a062996821ba575c3795881a0cb.webp";